export default __webpack_public_path__ + "static/media/inbond_gray.d1b33122.svg";